import { createSelector } from '@reduxjs/toolkit'
import { ExternalToolLinkResponse } from '@repo/shared-types'
import { externalToolLinkDataActions, externalToolLinkDataSelector } from '@repo/tools-store'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const contextualLinkSelector = createSelector(
  [
    externalToolLinkDataSelector.isInitialLoadingSelector,
    externalToolLinkDataSelector.payloadSelector,
    externalToolLinkDataSelector.hasErrorSelector,
  ],
  (isLoading: boolean, payload: ExternalToolLinkResponse | null, hasError: boolean) => ({
    isLoading,
    payload,
    hasError,
  }),
)

export const useContextualLink = () => {
  const dispatch = useDispatch()
  const { isLoading, payload, hasError } = useSelector(contextualLinkSelector)

  useEffect(() => {
    return () => {
      dispatch(externalToolLinkDataActions.clearData())
    }
  }, [dispatch])

  const link = payload?.link ?? ''
  const authLink = payload?.authLink ?? ''
  const type = payload?.type

  const hasUsableLink = Boolean(link || authLink)
  const hasEmptyLinkError = payload !== null && !hasUsableLink
  const isError = hasError || hasEmptyLinkError

  return {
    isLoading: isLoading || (!hasUsableLink && !isError),
    hasError: isError,
    link,
    authLink,
    type,
  }
}
